import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
    // Этот плагин работает только на стороне клиента
    if (process.client) {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const utmParams = ["utm_source", "utm_content", "utm_medium", "utm_campaign", "utm_term"];
            const utmData: Record<string, string> = {}; // Используем Record для типизации

            utmParams.forEach((param) => {
                if (urlParams.has(param)) {
                    const value = urlParams.get(param);
                    if (value) {
                        // Добавляем проверку, что значение не null
                        utmData[param] = value;
                    }
                }
            });

            // Закомментированная логика для document.referrer
            // if (!utmData.utm_source && document.referrer) {
            //     utmData.utm_source = document.referrer;
            // }

            // Сохраняем в cookie, только если есть хотя бы один параметр UTM
            if (Object.keys(utmData).length > 0) {
                const cookieValue = encodeURIComponent(JSON.stringify(utmData));
                const maxAge = 7 * 24 * 60 * 60; // 7 дней в секундах
                document.cookie = `utm=${cookieValue}; max-age=${maxAge}; path=/; SameSite=Lax`; // Добавлен SameSite=Lax для безопасности
                console.log("UTM data saved to cookie:", utmData); // Для отладки
            }
        } catch (error) {
            console.error("Error capturing UTM parameters:", error);
        }
    }
});
